<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="sale-person-list content-wrapper">
      <div class="page-header">{{ $t('market') }}</div>
      <div>
        <el-row>
          <el-col :span="4">
            <el-input :placeholder="$t('keyword')"
                      @input="isSearching = true"
                      v-model="keyword"></el-input>
          </el-col>
          <el-col :span="20" style="text-align: right;">
            <router-link to="market/add" style="float: right">
              <el-button type="primary" icon="el-icon-plus"> {{ $t('newMarket') }}</el-button>
            </router-link>
          </el-col>
        </el-row>
        <div style="margin-top: 25px">
          <el-table
            id="sale-person-list-table"
            :data="marketListDataSource"
            :row-class-name="getRowClassName"
            v-loading="isSearching"
            header-row-class-name="table-header-color"
            :default-sort = "{prop: sortKey, order: sortBy}"
            style="width: 100%">
            <el-table-column
              prop="name"
              :label="$t('name')">
            </el-table-column>
            <el-table-column
              prop="detail"
              :label="$t('description')">
            </el-table-column>
            <el-table-column
              :label="$t('totalAgent')">
              <template slot-scope="scope">{{ bindTotalAgent(scope.row) }}</template>
            </el-table-column>
            <el-table-column
              :label="$t('status')"
              width="80px">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isEnable === 1 ? 'success' : 'danger'" size="mini" disable-transitions>
                  {{ getMarketStatus(scope.row.isEnable) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small" icon="el-icon-edit" plain circle @click="onEditButtonClick(scope.row)"></el-button>
                <el-button type="danger" size="small" icon="el-icon-delete" plain circle @click="onRemoveMarketButtonClick(scope.row.id, scope.row.name)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Setting/ManageSetting/Market/List.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import SettingMarketApi from '@/api/setting/market-api'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import { filterDataByKeyword } from '@/services/general-service'
import { get, debounce } from 'lodash'
import { sortDataList, getStatusName } from '@/helpers'

export default {
  name: 'SettingMarketList',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  watch: {
    keyword: debounce(function () {
      this.isSearching = false
    }, 300),
    isSearching: function (value) {
      if (!value) {
        this.getMarketListDataSource()
      }
    }
  },
  data () {
    return {
      isLoading: true,
      keyword: '',
      isSearching: false,
      sortKey: 'name',
      sortBy: 'ascending',
      marketList: [],
      marketListDataSource: []
    }
  },
  created: async function () {
    try {
      this.isLoading = true
      const marketList = await SettingMarketApi.list()
      const sortedMarketList = sortDataList(marketList, this.sortKey, this.sortBy)
      this.marketList = sortedMarketList
      this.getMarketListDataSource()
    } catch (err) {
      this.alertError(err.message)
    }

    this.isLoading = false
  },
  methods: {
    getMarketListDataSource: function () {
      const searchKeys = ['name']
      const filteredMarketList = filterDataByKeyword(this.marketList, this.keyword, searchKeys)
      this.marketListDataSource = [...filteredMarketList]
    },
    getMarketStatus: function (status) {
      return this.$t(getStatusName(status))
    },
    bindTotalAgent: function (market) {
      const agentIdList = get(market, 'agentIdList', [])

      return agentIdList.length
    },
    onEditButtonClick: function (market) {
      this.$router.push({
        name: 'SettingMarketEdit',
        params: {
          market: market
        }
      })
    },
    onRemoveMarketButtonClick: async function (marketId, marketName) {
      const confirmMessage = this.$t('confirmRemoveMarketMessage', {
        marketName: `<strong>${marketName}</strong>`
      })
      const confirmButtonText = this.$t('confirmButtonText')
      const cancelButtonText = this.$t('cancelButtonText')
      const isConfirmRemove = await this.alertConfirmDelete(confirmMessage, confirmButtonText, cancelButtonText)

      if (!isConfirmRemove) {
        return false
      }

      this.removeMarket(marketId, marketName)
    },
    removeMarket: async function (marketId, marketName) {
      try {
        this.startLoading()

        await SettingMarketApi.remove(marketId)
        this.marketList = this.marketList.filter(item => item.id !== marketId)
        this.getMarketListDataSource()

        const notificationTitle = this.$t('removeMarketSuccess', {
          marketName: marketName
        })
        this.showNotificationSuccess(notificationTitle)
      } catch (err) {
        this.alertError(err.message)
      }
      this.stopLoading()
    },
    getRowClassName: function ({ row, rowIndex }) {
      if (row.isEnable === 1) {
        return ''
      }
      return 'disable-row'
    }
  }
}
</script>

<style scoped>
  #sale-person-list-table {
    width: 100%;
    border: 1px solid #dddddd;
    border-radius: 5px;
    box-shadow: 0px 3px 5px 1px #eeeeee;
  }
  .el-table th {
    background-color: #eeeeee;
  }
  .el-form > div {
    text-align: left;
  }
</style>
